import type { Tag } from 'src/components/sections/HeroCarousel/hero-carousel'

type Props = {
  tags?: Tag[]
}

export const TagList = ({ tags }: Props) => {
  const hasTags = tags?.length

  if (!hasTags) {
    return null
  }

  return (
    <div className="flex gap-2 items-center pb-2 flex-wrap">
      {tags?.map((el: Tag, index: number) => (
        <span
          key={`tag-${index}`}
          className="rounded-xl px-2 py-1 text-xs border border-solid"
          style={{
            color: el.styles?.color,
            backgroundColor: el.styles?.backgroundColor,
            borderColor: el.styles?.borderColor,
          }}
        >
          {el.text}
        </span>
      ))}
    </div>
  )
}
